<template>
  <div class="wrapper" v-if="isAdmin">
    <v-autocomplete
      v-if="show"
      :readonly="readonly"
      v-model="vendor_id"
      :items="vendorOptions"
      :search-input.sync="vendorSearchInput"
      :loading="vendorLoading"
      cache-items
      item-text="text"
      item-value="value"
      :class="classLists"
      outlined
      hide-details
      :placeholder="$t(placeholder)"
      dense
      @change="onChanageVendorId"
      :no-data-text="noDataText"
    >
      <template v-if="showFilter" v-slot:prepend-inner>
        <svg-icon icon="filter"></svg-icon>
      </template>
      <template slot="append">
        <svg-icon icon="triagle_down"></svg-icon>
      </template>
    </v-autocomplete>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { find, debounce, isEmpty } from 'lodash';
const SORT_DEBOUNCE_DELAY = 500;

export default {
  name: 'VendorSelector',
  props: {
    showFilter: { type: Boolean, require: false, default: false },
    show: { type: Boolean, require: false, default: true },
    placeholder: {
      type: String,
      default: 'vendor.label.selector_placeholder',
    },
    classLists: {
      type: String,
      default: 'v-select--normal-size v-select--highlight',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    firstValue: {
      type: Object,
      default: () => {
        return {
          // text: 'common.options.all',
          // value: '',
        };
      },
    },
    preValue: {
      type: Object,
      default: () => {
        return {
          text: '',
          value: '',
        };
      },
    },
    readonly: {
      type: Boolean, require: false, default: false,
    },
  },
  data () {
    return {
      vendor_id: '',
      vendorOptions: [],
      vendorSearchInput: '', // todo
      vendorLoading: false,
    };
  },
  created () {
    if (!this.isAdmin) {
      return;
    }
    this.vendor_id = this.value;
    this.searchVendors('');
    if (this.preValue && this.preValue.text) {
      this.vendor_id = this.preValue.value;
      this.vendorOptions = [this.preValue];
    }
  },
  watch: {
    value (newValue) {
      this.vendor_id = newValue;
    },
    vendorSearchInput (val) {
      let findedVendor;
      if (val) {
        findedVendor = find(this.vendorOptions, { text: val });
      }

      return val && !findedVendor && this.debounceSerchVendor(val);
    },

  },
  methods: {
    ...mapActions({
      searchVendor: 'vendorStore/searchVendor',
    }),
    onChanageVendorId (val) {
      this.$emit('change', val);
      this.$emit('input', val);
    },
    async searchVendors (name) {
      this.vendorLoading = true;
      const respVendor = await this.searchVendor({
        searchBy: name,
      });

      this.vendorLoading = false;
      const { status, data } = respVendor;
      if (status && data && data.result) {
        const vendors = data.result.data;
        this.vendorOptions = vendors.map(item => { return { text: item.name, value: item.id }; });
        if (!isEmpty(this.firstValue)) {
          const objectFirst = this.firstValue;
          objectFirst.text = this.$t(this.firstValue.text);
          this.vendorOptions.unshift(objectFirst);
        }
      }
    },
    debounceSerchVendor: debounce(function (val) {
      return this.searchVendors(val);
    }, SORT_DEBOUNCE_DELAY),
    setPreValue (preValue) {
      this.vendor_id = preValue.value;
      this.vendorOptions = [preValue];
    },
  },
  computed: {
    ...mapGetters({
      isAdmin: 'userStore/isAdmin',
    }),
    noDataText () {
      if (this.vendorLoading) {
        return this.$t('common.message.loading');
      }
      return this.$t('common.message.no_data');
    },
  },
};
</script>
<style scoped>
.wrapper {}
</style>
